export default __webpack_public_path__ + "static/iso9001-06a3533daca31b78769d9f3e5e9df4bb.svg";